import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Typography } from '@mui/material';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useModal } from '@lwtears/lwt-common-frontend/lib/Modal';
import { checkFor2025AuditorUser } from 'state/modules/user';
import { translate } from 'translations/translator';
import { AppStoreState, SETTING_TYPES } from 'types';
import SwitchEditionModal from '../Modals/SwitchEditionModal';

const t = (key: string, options?) => translate('home', key, options);

const SwitchEditionButton = () => {
  const user = useSelector(({ user }: AppStoreState) => user);
  const currentWorkbook: any = useSelector(({ app }: AppStoreState) => app.currentWorkbook);

  const [, { openModal, closeModal }] = useModal();

  const isModalSuppressed = user?.settings?.[SETTING_TYPES.SUPPRESS_2025_SWITCH];

  const goTo2022 = () => {
    closeModal();
    window.open(process.env.REACT_APP_AUTH_2025_REDIRECT_URI!, '_blank', 'noopener,noreferrer');
  };

  const handleSwitch = () => {
    if (isModalSuppressed) {
      goTo2022();
      return;
    }
    openModal({
      body: <SwitchEditionModal switchAction={goTo2022} />,
      getContainerStyles: defaultStyles => ({
        ...defaultStyles,
        width: '426px',
        backgroundColor: '#fff'
      }),
      options: { closeOnBackdropClick: true }
    });
  };

  const is2025Auditor = checkFor2025AuditorUser(user);

  if ((!user?.has2025Licenses && !is2025Auditor) || !currentWorkbook) return null;

  return (
    <Button
      onClick={handleSwitch}
      sx={{ ...style.button, border: `2px solid ${currentWorkbook.textColor}` }}
    >
      <Typography variant="button" sx={{ marginRight: '15px', color: currentWorkbook.textColor }}>
        {t('view2025Edition')}
      </Typography>
      <FontAwesomeIcon icon={faArrowRight} color={currentWorkbook.textColor} />
    </Button>
  );
};

export default SwitchEditionButton;

const style = {
  button: {
    marginRight: '15px',
    minWidth: '200px',
    width: 'max-content',
    alignSelf: 'center',
    '&:hover': {
      backgroundColor: 'unset !important',
      transform: 'scale(1.02, 1.02) !important'
    }
  }
};
